import { useEffect, useState } from "react";
import AppButton from "../elements/AppButton";
import useApiRequest from "../../helpers/api_request";
import { AxiosError } from "axios";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { BASE_URL } from "../../helpers/constants";
import { selectAccessToken } from "../../features/auth/authSlice";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import useDataSources from "../../hooks/useDataSources";
import AppSpinner from "../elements/AppSpinner";
import useErrorToast from "../../helpers/errorToast";

const UploadTemplate = () => {
    const [saving, setSaving] = useState(false)
    const accessToken = useAppSelector(selectAccessToken);
    const [name, setName] = useState("");
    const [files, setFiles] = useState<FileList | null>();
    const apiRequest = useApiRequest()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const errorToast = useErrorToast()

    const uploadFile = async () => {
        if (name === "") {
            dispatch(showToastMessage({
                message: "Type is required",
                type: "error",
                position: toast.POSITION.TOP_RIGHT
            }));
            return
        }
        const file = files?.[0]
        if (!file) {
            dispatch(showToastMessage({
                message: "Template is required",
                type: "error",
                position: toast.POSITION.TOP_RIGHT
            }));
            return
        }
        const formData = new FormData();
        formData.append('file', file);

        let url =BASE_URL;
        if (name==="Coffee") {
            url+="/api/excel/import-coffee"
        }else if(name==="Maize"){
            url+="/api/excel/import-maize"
        }else if(name==="Tea"){
            url+="/api/excel/import-tea"
        }else if(name==="Data-sources"){
            url+="/api/excel/import-datasource"
        }
        setSaving(true)
        await apiRequest({
            method: 'post',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${accessToken}`,
            },
            data:formData
        }).then((response) => {
            setSaving(false)
            dispatch(showToastMessage({
                message: name+" Template Uploaded",
                type: "success",
                position: toast.POSITION.TOP_RIGHT
            }));
            setFiles(null)
            setName("")
        }).catch((error) => {
            errorToast(error);
            setSaving(false)
        });
    }
    return (
        <div>
            <div className="card">
                <div className=" card-body min-h-half-screen">

                    <div className="flex">
                        <nav className="flex justify-between " aria-label="Breadcrumb">
                            <ol className="inline-flex items-center mb-3 sm:mb-0">
                                <li>
                                    <div className="flex items-center">
                                        <h5 className=" card-title ">Upload Template</h5>
                                    </div>
                                </li>

                            </ol>
                        </nav>
                    </div>

                    <div className=" h-fit flex-grow flex flex-col justify-center ">
                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 ">Template Type</label>
                            <select value={name} onChange={(e)=> setName(e.target.value)} name="" className="form-input-2" id="">
                                <option value="">--Select--</option>
                                <option value="Coffee">Coffee Template</option>
                                <option value="Maize">Maize Template</option>
                                <option value="Tea">Tea Template</option>
                                <option value="Data-sources">Data Sources Template</option>
                            </select>
                        </div>

                        <div className=" w-2/3 mt-4">
                            <label className="block text-sm font-medium text-gray-700 "> Template</label>
                            <input  onChange={(e) => setFiles(e.target.files)} type="file" id="name" className="form-input-2" placeholder="" />
                        </div>

                        <div className="w-2/3 mt-4">
                            <AppButton callBackFun={() => uploadFile()} showLoader={saving} spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black" className="prim-btn-2" text="Upload" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UploadTemplate;